import React from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import CopyrightFooter from "../Components/CopyrightFooter";
import Error404 from "../Components/Error404";
import Header from "../Components/Headers";
import CakeDetails from "./CakeDetails";

export default function CakeRoom() {
  const { url } = useRouteMatch();
  return (
    <React.Fragment>
      <Header Layout="Cake Room" />
      <main className="pt-50">
        <Switch>
          <Route path={url} exact component={CakeDetails} />
          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </main>
      <CopyrightFooter />
    </React.Fragment>
  );
}
